import Typography from '@mui/material/Typography';
import { FlexBox } from '../layout';
import BaseDialog from './BaseDialog';

interface UnsavedChangesDialogProps {
  open: boolean;
  onLeave: () => void;
  onCancel: () => void;
}

const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  open,
  onLeave,
  onCancel,
}) => (
  <BaseDialog
    fullWidth={false}
    maxWidth="sm"
    open={open}
    title="Unsaved changes"
    footerAction={{
      left: {
        children: 'Cancel',
        onClick: onCancel,
        color: 'softGold',
      },
      right: {
        children: 'Leave',
        onClick: onLeave,
      },
    }}
  >
    <FlexBox p={2}>
      <Typography>Changes you made may not be saved.</Typography>
    </FlexBox>
  </BaseDialog>
);

export default UnsavedChangesDialog;
